<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="2.5"
      y="5"
      width="15"
      height="12.5"
      rx="2"
      stroke="url(#paint0_linear_2355_13079)"
      stroke-width="1.5"
    />
    <path
      d="M2.5 8.33333C2.5 7.08718 2.5 6.4641 2.76795 6C2.94349 5.69596 3.19596 5.44349 3.5 5.26795C3.9641 5 4.58718 5 5.83333 5H14.1667C15.4128 5 16.0359 5 16.5 5.26795C16.804 5.44349 17.0565 5.69596 17.2321 6C17.5 6.4641 17.5 7.08718 17.5 8.33333V8.33333H2.5V8.33333Z"
      fill="url(#paint1_linear_2355_13079)"
    />
    <path
      d="M5.83398 2.5L5.83398 5"
      stroke="url(#paint2_linear_2355_13079)"
      stroke-linecap="round"
    />
    <path
      d="M14.166 2.5L14.166 5"
      stroke="url(#paint3_linear_2355_13079)"
      stroke-linecap="round"
    />
    <rect
      x="5.83398"
      y="10"
      width="3.33333"
      height="1.66667"
      rx="0.5"
      fill="url(#paint4_linear_2355_13079)"
    />
    <rect
      x="5.83398"
      y="13.332"
      width="3.33333"
      height="1.66667"
      rx="0.5"
      fill="url(#paint5_linear_2355_13079)"
    />
    <rect
      x="10.834"
      y="10"
      width="3.33333"
      height="1.66667"
      rx="0.5"
      fill="url(#paint6_linear_2355_13079)"
    />
    <rect
      x="10.834"
      y="13.332"
      width="3.33333"
      height="1.66667"
      rx="0.5"
      fill="url(#paint7_linear_2355_13079)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2355_13079"
        x1="10"
        y1="5"
        x2="10"
        y2="17.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2355_13079"
        x1="10"
        y1="5"
        x2="10"
        y2="8.33333"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_2355_13079"
        x1="5.83398"
        y1="3.75"
        x2="4.83398"
        y2="3.75"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_2355_13079"
        x1="14.166"
        y1="3.75"
        x2="13.166"
        y2="3.75"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_2355_13079"
        x1="7.50065"
        y1="10"
        x2="7.50065"
        y2="11.6667"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_2355_13079"
        x1="7.50065"
        y1="13.332"
        x2="7.50065"
        y2="14.9987"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_2355_13079"
        x1="12.5007"
        y1="10"
        x2="12.5007"
        y2="11.6667"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_2355_13079"
        x1="12.5007"
        y1="13.332"
        x2="12.5007"
        y2="14.9987"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
    </defs>
  </svg>
</template>
